import api from '../backend-api.js';

export default {
  async getAttributions(facilityId) {
    console.log("getAttributions()");
    let url = "/attribution?facilityId=" + facilityId;
    return (await api.getData(url)).data;
  },

  async deleteAttribution(attributionRange) {
    console.log("deleteAttributionByRange() ", attributionRange);
    await api.deleteData('/attribution', attributionRange);
  },

  async createAttribution(attribution) {
    console.log("createAttribution() ", attribution);
    await api.postData('/attribution', attribution);
  },

  async updateAttribution(attribution) {
    console.log("updateAttribution()", attribution);
    await api.putData('/attribution', attribution);
  },

  async getContainerDetailsByBarcode(barcode) {
    let url = '/attribution/detail?barcodeValue=' + barcode
    return (await api.getData(url)).data;
  },
};

